import type { ComponentType } from 'react';
import React from 'react';

import { SmartCardProvider } from '@atlaskit/link-provider';

import { getSmartCardRenderers } from '@confluence/fabric-extension-lib';
import { useSmartCardProviderFeatureFlags } from '@confluence/linking-platform';
import { useSessionData } from '@confluence/session-data';

export function withSmartCardProviderContext<T>(WrappedComponent: ComponentType<T>) {
	return (props: any) => {
		const linkingPlatformFeatureFlags = useSmartCardProviderFeatureFlags('editor');

		const { isAdminHubAIEnabled } = useSessionData();

		return (
			<SmartCardProvider
				{...getSmartCardRenderers()}
				featureFlags={linkingPlatformFeatureFlags}
				isAdminHubAIEnabled={isAdminHubAIEnabled}
				product="CONFLUENCE"
			>
				<WrappedComponent {...props} />
			</SmartCardProvider>
		);
	};
}
